import * as React from 'react';
import { GlobalizationContext } from '../globalization/GlobalizationContext';
/**
 * @hidden
 */

export var useLocalization = function useLocalization() {
  return React.useContext(GlobalizationContext).localization;
};